import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let ItemsCarousel = class ItemsCarousel extends Vue {
  constructor() {
    super(...arguments);
    this.selectedModel = null;
    this.scrollCounter = 0;
    this.scrolling = false;
    this.btnLeft = null;
    this.btnRight = null;
    this.counter = 0;
    this.textTypeTop = "";
    // @Watch("activeElement")
    // onActiveElementChange() {
    //     if(this.itemsType == "frontali") {
    //         console.log("Item Frontali : ", this.activeElement);
    //     }
    //     else if(this.itemsType == "coloriFrontali") {
    //         console.log("Item Colori : ", this.activeElement);
    //     }
    //     else if(this.itemsType == "aste") {
    //         console.log("Item Aste : ", this.activeElement);
    //     }
    //     else if(this.itemsType == "lentiSole") {
    //         console.log("Item Lenti Sole : ", this.activeElement);
    //     }
    // }
    // @Watch("itemsCarousel")
    // onItemsCarouselChanged() {
    //     if(this.itemsType == "frontali") {
    //         console.log("Items Frontali : ", this.itemsCarousel);
    //     }
    //     else if(this.itemsType == "coloriFrontali") {
    //         console.log("Items Colori Frontali : ", this.itemsCarousel);
    //     }
    //     else if(this.itemsType == "aste") {
    //         console.log("Items Aste : ", this.itemsCarousel);
    //     }
    //     else if(this.itemsType == "lentiSole") {
    //         console.log("Items Lenti Sole : ", this.itemsCarousel);
    //     }
    // }
  }
  mounted() {}
  get items() {
    if (this.itemsType == "frontali") {
      return this.itemsCarousel.map(item => {
        return {
          ...item,
          name: item.U_THE_MODELLO,
          imageUrl: item.imageUrl,
          TYPE: item.TYPE,
          ORDERING: item.ORDERING,
          U_THE_SOTTOLINEA: item.U_THE_SOTTOLINEA
        };
      });
    } else if (this.itemsType == "coloriFrontali") {
      return this.itemsCarousel.map(item => {
        return {
          ...item,
          name: item.PLASTICA,
          imageUrl: item.imageUrl,
          TYPE: null,
          ORDERING: item.Order
        };
      }).sort((a, b) => {
        if (a.name.startsWith("EP") && !b.name.startsWith("EP")) {
          return -1;
        }
        if (!a.name.startsWith("EP") && b.name.startsWith("EP")) {
          return 1;
        }
        return a.name.localeCompare(b.name);
      });
    } else if (this.itemsType == "aste") {
      return this.itemsCarousel.map(item => {
        return {
          ...item,
          name: item.U_THE_COLORE,
          imageUrl: process.env.VUE_APP_COLORS_URL + item.U_THE_COLORE + ".jpg",
          TYPE: "",
          ORDERING: item.Order
        };
      });
    } else if (this.itemsType == "lentiSole") {
      return this.itemsCarousel.map(item => {
        return {
          ...item,
          name: item.ItemName,
          imageUrl: item.imageUrl,
          TYPE: "",
          ORDERING: ""
        };
      });
    }
    return this.itemsCarousel;
  }
  get totalPages() {
    return Math.ceil(this.items.length / 6); // Arrotonda per eccesso
  }
  //voglio un get currentIndex tipo questo 
  get keyedItems() {
    return this.items.map(item => item);
  }
  get currentIndex() {
    return this.keyedItems.findIndex(item => item === this.selectedModel);
  }
  get itemActive() {
    return this.$store.state.selectedModel;
  }
  selectItem(item) {
    this.selectedModel = item;
    this.counter = this.items.indexOf(item);
    if (window.innerWidth > 1300 && !this.itemsWrap) {
      this.updateCarousel(0, "smooth");
    }
    this.itemSelected(item);
  }
  itemSelected(item) {
    this.$emit("item-selected", item);
  }
  scrollLeft() {
    this.scrolling = true;
    const container = this.$refs.carousel;
    const scrollValue = container.scrollLeft - container.clientWidth;
    container.scrollTo({
      top: 0,
      left: scrollValue,
      behavior: "smooth"
    });
    setTimeout(() => {
      this.scrolling = false;
    }, 1000);
    this.counter = Math.max(this.counter - 6, 0); // Decrementa di una pagina, ma non sotto 0
  }
  getPlaceholder(itemsType) {
    // Esempio di logica per decidere quale placeholder usare in base al tipo
    if (itemsType === 'frontali') {
      return 'images/model_placeholder.png';
    } else {
      return 'images/errore-immagine.jpg';
    }
  }
  onCounterChange(newVal) {
    const page = Math.floor(newVal / 6) + 1;
    if (page === 1) {
      this.btnLeft = true;
      this.btnRight = false;
    } else if (page === this.totalPages) {
      this.btnLeft = false;
      this.btnRight = true;
    } else {
      this.btnLeft = false;
      this.btnRight = false;
    }
  }
  scrollRight() {
    this.scrolling = true;
    const container = this.$refs.carousel;
    const scrollValue = container.scrollLeft + container.clientWidth;
    container.scrollTo({
      top: 0,
      left: scrollValue,
      behavior: "smooth"
    });
    setTimeout(() => {
      this.scrolling = false;
    }, 1000);
    this.counter = Math.min(this.counter + 6, this.items.length - 1); // Incrementa, ma non oltre l'ultimo elemento
  }
  onItemsCarouselChange(newVal, oldVal) {
    if (newVal !== oldVal && !this.itemsWrap) {
      this.updateCarousel(0, "smooth");
      this.counter = 0;
    }
  }
  // eslint-disable-next-line no-undef
  updateCarousel(waitTimeout = 0, behavior = "smooth") {
    const container = this.$refs.carousel;
    if (container) {
      const itemsPerPage = 6; // Numero di elementi visibili
      const itemWidth = container.clientWidth / itemsPerPage;
      // Calcola la posizione target da scrollare
      let scrollValue = (this.currentIndex - Math.floor(itemsPerPage / 2)) * itemWidth;
      // Limita lo scroll per evitare che vada oltre il primo o l'ultimo elemento
      const maxScroll = container.scrollWidth - container.clientWidth;
      const minScroll = 0;
      scrollValue = Math.min(Math.max(scrollValue, minScroll), maxScroll);
      setTimeout(() => {
        container.scrollTo({
          top: 0,
          left: scrollValue,
          behavior: behavior
        });
      }, waitTimeout);
    }
  }
};
__decorate([Prop({
  default: []
})], ItemsCarousel.prototype, "itemsCarousel", void 0);
__decorate([Prop({
  default: false
})], ItemsCarousel.prototype, "itemsWrap", void 0);
__decorate([Prop({
  default: ""
})], ItemsCarousel.prototype, "itemsType", void 0);
__decorate([Prop({
  default: ""
})], ItemsCarousel.prototype, "activeElement", void 0);
__decorate([Watch("counter")], ItemsCarousel.prototype, "onCounterChange", null);
__decorate([Watch("itemsCarousel")], ItemsCarousel.prototype, "onItemsCarouselChange", null);
ItemsCarousel = __decorate([Component({})], ItemsCarousel);
export default ItemsCarousel;